import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

// 加载modules数据
import global from './modules/global';
import login from './modules/login';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
    login,
  },
  getters,
});

export default store;
